import { Module } from '@nestjs/common';
import { MikroOrmModule } from '@mikro-orm/nestjs';
import { Chapter } from './entities/chapter.entity';
import { ChapterService } from './services/chapter.service';
import { ChapterController } from './controllers/chapter.controller';
import { Newsfeed } from '../newsfeed/entities/newsfeed.entity';

@Module({
  imports: [MikroOrmModule.forFeature([Chapter, Newsfeed])],
  controllers: [ChapterController],
  providers: [ChapterService],
  exports: [ChapterService],
})
export class ChapterModule {}
